import { render, staticRenderFns } from "./FareDetails.vue?vue&type=template&id=6a73426c&scoped=true&"
import script from "./FareDetails.vue?vue&type=script&lang=js&"
export * from "./FareDetails.vue?vue&type=script&lang=js&"
import style0 from "./FareDetails.vue?vue&type=style&index=0&id=6a73426c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a73426c",
  null
  
)

export default component.exports